import React, { useState, useEffect } from "react";
import "./basicProfile.css";
import {
  TextInputField,
  TextInput,
  Select,
  option,
  FilePicker,
} from "evergreen-ui";
import SaveBTN from "./SaveBtn/SaveBTN";
import SubmittedQoutes from "../../SubmittedQuotes/SubmittedQoutes";
import SubmitButton from "../../Buttons/SubmitButton/SubmitButton";

const BankDetails = ({ allData, setAllData, handleProfileUpdate }) => {
  const [switchEdit, setswitchEdit] = useState(false);
  const [getAllData, setgetAllData] = useState(allData);
  const handleBasicProfile = (e) => {
    const { name, value } = e.target;
    setAllData({
      ...allData,
      [name]: value,
    });
  };
  const saveHandler = () => {
    handleProfileUpdate();
    setswitchEdit(false);
  };
  useEffect(() => { }, []);
  useEffect(() => { }, [switchEdit]);

  return (
    <div className="basicProfileMainContainer">
      <div className="basicProfileFirtRow">
        <div className="basicProfileMainContainerHead">
          <div>
            <img src="./images/stratum/bankDetails.svg" alt="" />
          </div>
          <div className="basicdetailName">Bank Details</div>
        </div>
        {!switchEdit ? (
          <div
            className="editInPf"
            onClick={() => {
              setswitchEdit(true);
            }}
          >
            <img src="./images/stratum/edit.svg" alt="" />
          </div>
        ) : (
          <div
            className="editInPf"
            onClick={() => {
              setswitchEdit(false);
            }}
          >
            <img src="./images/stratum/closeLogo.svg" alt="" />
          </div>
        )}
      </div>
      <div className="detailsColumInProfile">
        <div>
          <p className="subHeadProfileTab"> Bank details</p>
          {!switchEdit ? (
            <div className="inputDesabledDta">
              {allData.bankDetails ? allData.bankDetails : "NA"}
            </div>
          ) : (
            <TextInput
              className="pfInputManage"
              width={279}
              height={32}
              placeholder="Enter Bank Details"
              name="bankDetails"
              value={allData.bankDetails}
              onChange={handleBasicProfile}
              required
            />
          )}
          <p className="subHeadProfileTab"> SWIFT CODE</p>
          {!switchEdit ? (
            <div className="inputDesabledDta">
              {allData.SWIFTcode ? allData.SWIFTcode : "NA"}
            </div>
          ) : (
            <TextInput
              className="pfInputManage"
              width={279}
              height={32}
              placeholder="SWIFT CODE"
              name="SWIFTcode"
              value={allData.SWIFTcode}
              onChange={handleBasicProfile}
              required
            />
          )}
        </div>
        <div>
          {" "}
          <p className="subHeadProfileTab">Account Number</p>
          {!switchEdit ? (
            <div className="inputDesabledDta">
              {allData.accountNumber ? allData.accountNumber : "NA"}
            </div>
          ) : (
            <TextInput
              className="pfInputManage"
              width={279}
              height={32}
              placeholder="Enter Account Number"
              name="accountNumber"
              value={allData.accountNumber}
              onChange={handleBasicProfile}
              required
            />
          )}
        </div>
        <div>
          {" "}
          <p className="subHeadProfileTab">IBAN Number</p>
          {!switchEdit ? (
            <div className="inputDesabledDta">
              {allData.IBANnumber ? allData.IBANnumber : "NA"}
            </div>
          ) : (
            <TextInput
              className="pfInputManage"
              width={279}
              height={32}
              placeholder="Enter IBAN Number"
              name="IBANnumber"
              value={allData.IBANnumber}
              onChange={handleBasicProfile}
              required
            />
          )}
        </div>
      </div>
      {switchEdit && (
        <div className="btnmarginPf">
          {/* <SaveBTN handlesave={saveHandler} /> */}
          <SubmitButton ApplyFunction={saveHandler} text={"Save Changes"} />
        </div>
      )}
    </div>
  );
};

export default BankDetails;
